<template>
  <div>
    <el-button type="primary" @click="dialog_config.is_show = true">选择标题</el-button>
    <view-list
      class="mt-10"
      :value="formItem.value"
      view-key="name"
      :is-show-border="true"
    />
    <el-dialog
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      :append-to-body="true"
    >
      <title-list-select
        v-if="dialog_config.is_show"
        ref="title_form_select"
        :channel-interface="channelInterface"
        :value="formItem.value"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_config.is_show = false">取 消</el-button>
        <el-button type="primary" @click="dialog_config.confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {
    'view-list': () => import('@/components/base/view-list'),
    'title-list-select': () => import('@/components/business/title/title-list-select'),
  },
  props: {
    channelInterface: {
      type: String,
      required: true,
    },
    formItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog_config: {
        is_show: false,
        title: '标题',
        confirm: async() => {
          const { getAssignSelection } = this.$refs.title_form_select;
          this.formItem.value = await getAssignSelection();
          this.dialog_config.is_show = false;
        },
      },
    };
  },
  methods: {
    /**
     * 删除
     * @param {number} index 数据项下标
     * @returns {void}
     */
    onDel(index) {
      this.value.splice(index, 1);
    },
  },
};
</script>
